import React from 'react';
import PatientEmrExport from './PatientEmrExport';

const EmrExportPage = () => <PatientEmrExport isMedicalHistoryPage />;

export default EmrExportPage;
